import React from 'react';
import './MoneySuggestions.scss';

interface MoneySuggestion {
    value: number;
    label: string;
}

interface MoneySuggestionsProps {
    suggestions: MoneySuggestion[];
    onSelectSuggestion: (item: MoneySuggestion) => void;
}

const MoneySuggestions: React.FC<MoneySuggestionsProps> = ({
    suggestions,
    onSelectSuggestion,
}) => {
    if (!suggestions || suggestions.length === 0) {
        return null;
    }

    return (
        <div className="money-suggestions">
            <div className="money-suggestions-list">
                {suggestions.map((item, index) => (
                    <button
                        key={index}
                        className="money-suggestion-item"
                        onClick={() => onSelectSuggestion(item)}
                        type="button"
                    >
                        {item.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default MoneySuggestions;
